import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grain flex flex-col items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="mb-10"><Logo /></div>
      <div className="mfp-card p-10 max-w-md w-full text-center">
        <XCircle className="w-14 h-14 text-[#64748B] mx-auto mb-5" />
        <h1 className="font-head text-2xl font-bold mb-2">Pago cancelado</h1>
        <p className="text-sm text-[#94A3B8] mb-6">No se realizó ningún cargo. Puedes volver cuando quieras.</p>
        <div className="flex items-center justify-center gap-3">
          <button data-testid="cancel-back-pricing" onClick={() => navigate("/precios")}
            className="inline-flex items-center gap-2 bg-[#FF334B] hover:bg-[#E0223A] text-white font-semibold px-6 py-3 rounded-full transition-colors">
            Ver precios
          </button>
          <button onClick={() => navigate("/dashboard")}
            className="inline-flex items-center gap-2 border border-white/15 hover:border-white/30 font-semibold px-6 py-3 rounded-full transition-colors">
            <ArrowLeft className="w-4 h-4" /> Al estudio
          </button>
        </div>
      </div>
    </div>
  );
}
